import React from 'react';
import i18n from 'i18next';
import { classnames } from '../../../../../../utils/classnames';
import './itemCardInfos.css';

function ItemCardInfoDetail({information}) {
    const locale = i18n.language;

    if (information.type === 'date' && information.timezone) {
        return new Date (information.value).toLocaleString(locale, {
            timeZone: information.timezone,
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        })
    }
    if (information.type === 'amount' && information.currency) {
        return new Intl.NumberFormat(i18n.language.replace("_", "-"), { style: 'currency', currency: information.currency, currencyDisplay: 'narrowSymbol' }).format(information.value)
    }
    return information.value;
}

export default function ItemCardInfos({ title = null, alternativeStyle = false, informations = [] }) {
    return (
        <div className={classnames('neo-item-card-infos', {'alternative-style' : alternativeStyle})}>
            <h6 className={classnames('neo-item-card-infos-title')}>{title}</h6>
            {informations.map((information, index) => (
                <div key={index}>
                    <dt className='neo-item-card-key'>{information.label}</dt>
                    <dd className='neo-item-card-value'>
                        <ItemCardInfoDetail information={information}/>
                    </dd>
                </div>
            ))}
        </div>
    )
}